module.exports = __webpack_public_path__ + "img/bg-gradient-gold2.d01c4c53.svg";